import { render, staticRenderFns } from "./digiPayTranscation.vue?vue&type=template&id=6c61c7b9&scoped=true&"
import script from "./digiPayTranscation.vue?vue&type=script&lang=js&"
export * from "./digiPayTranscation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61c7b9",
  null
  
)

export default component.exports